import * as _ from "lodash";
var WindowCloseNotifierHelper = /** @class */ (function () {
    function WindowCloseNotifierHelper() {
    }
    WindowCloseNotifierHelper.setMessage = function (message) {
        if (message && _.isFunction(message)) {
            window.onbeforeunload = message;
        }
        else if (message) {
            window.onbeforeunload = function (e) {
                if (e) {
                    e.returnValue = message;
                }
                return message;
            };
        }
        else {
            window.onbeforeunload = null;
        }
    };
    return WindowCloseNotifierHelper;
}());
export { WindowCloseNotifierHelper };
